import { render, staticRenderFns } from "./Rulement.vue?vue&type=template&id=0e2c56be&scoped=true&"
import script from "./Rulement.vue?vue&type=script&lang=js&"
export * from "./Rulement.vue?vue&type=script&lang=js&"
import style0 from "./Rulement.vue?vue&type=style&index=0&id=0e2c56be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2c56be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow})
